import {useEffect, useRef} from "react"
import { render } from "react-dom"


import "./frontend.css"

const paraDivsToUpdate = document.querySelectorAll(".long-para-block-update-me")

paraDivsToUpdate.forEach( div => {
    const dataRaw = div.querySelector("pre").innerHTML
    const data = JSON.parse(dataRaw)
    render(<ParaBlock {...data}/>, div)
    div.classList.remove(".long-para-block-update-me")
})

function ParaBlock(props){
    const paraBlockHeading = useRef(null)
    const paragraphsRef = useRef(null)
    const listRef = useRef(null)

    useEffect( () => {        
        paraBlockHeading.current.innerHTML = props.heading
        props.paragraphs.forEach( paragraph => {
            const paraElement = document.createElement('p')
            paraElement.innerHTML = paragraph
            paragraphsRef.current.appendChild(paraElement)
        })

        if(props.list){
            props.list.forEach( listItem => {
                const listItemArray = listItem.split("<br>")
                const listElement = document.createElement('li')
                const listHeader = document.createElement("h3")
                const emptyDiv = document.createElement("div")
                listHeader.innerHTML = listItemArray[0]
                listElement.appendChild(listHeader)
                listRef.current.appendChild(listElement)
                listItemArray.splice(1).forEach( para => {
                    const paragraphDiv = document.createElement("p")
                    paragraphDiv.innerHTML = para
                    emptyDiv.appendChild(paragraphDiv)
                    listElement.appendChild(emptyDiv)
                    listRef.current.appendChild(listElement)
                })
                
            })            
        }
    }, [])

    return (
        <>
            <h2 class="ong-paragraphs-with-lists-heading" ref={paraBlockHeading}>OUR WORK</h2>
            <div class="long-paragraphs-with-lists-paragraphs">
                <div class="the-paragraphs" ref={paragraphsRef}>
                </div>
                <ul ref={listRef}>

                </ul>
            </div>
        </>
    )
}

